import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import FilterWrapperBasic from '@adv-mt/mt-filter-wrapper-basic'
import FormCheckboxField from '@adv-mt/mt-form-checkbox-field'

const LEGACY_WRAPPER = 'legacy'
const CHECKED_ID = 'checked'
const UNCHECKED_ID = 'unchecked'

const FormIsCertified = ({id, value, type, onChange, wrapper = LEGACY_WRAPPER}) => {
  const {domain, i18n} = useContext(Context)

  const config = domain.get('config')
  const {FILTER_NAMES} = config.get('search')
  const TRACKING_FILTER_NAMES = config.get('TRACKING_FILTER_NAMES')

  const _handleOnChange = (e, {checked}) => {
    setTimeout(() => {
      onChange(e, {
        field: FILTER_NAMES.IS_CERTIFIED,
        value: checked,
        lastFilter: TRACKING_FILTER_NAMES[FILTER_NAMES.IS_CERTIFIED]
      })
    }, 0)
  }

  const handleChecked = ({value: selectedValue}) => {
    const [currentValue] = selectedValue

    _handleOnChange(null, {checked: currentValue === CHECKED_ID})
  }

  if (wrapper === LEGACY_WRAPPER) {
    return (
      <FormCheckboxField
        checked={value}
        id={id || FILTER_NAMES.IS_CERTIFIED}
        label={i18n.t('FORM.CERTIFIED_ADS')}
        onChange={_handleOnChange}
        helpText={i18n.t('FORM.CERTIFIED_ADS_HELP_TEXT')}
      />
    )
  }

  return (
    <FilterWrapperBasic
      filters={[
        {
          label: i18n.t('FORM.CERTIFIED_ADS'),
          name: FILTER_NAMES.IS_CERTIFIED,
          options: [{id: CHECKED_ID, label: i18n.t('FORM.CERTIFIED_ADS')}],
          type
        }
      ]}
      group={`${FILTER_NAMES.IS_CERTIFIED}Group`}
      helpText={i18n.t('FORM.CERTIFIED_ADS_HELP_TEXT')}
      legend={i18n.t('FORM.CERTIFIED_ADS')}
      onChange={handleChecked}
      value={{[FILTER_NAMES.IS_CERTIFIED]: [value ? [CHECKED_ID] : [UNCHECKED_ID]]}}
      wrapper={wrapper}
    />
  )
}

FormIsCertified.displayName = 'FormIsCertified'
FormIsCertified.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  wrapper: PropTypes.string
}

export default FormIsCertified
